





















import Vue from 'vue';
import GalleryItemPreviewModal from '@/containers/modals/gallery-item-preview/index.vue';

export default Vue.extend({
  components: {
    GalleryItemPreviewModal,
  },
  props: {
    galleryItemId: {
      type: [String, Number],
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    thumbnailImageUrl: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
    },
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      modalOpened: false,
    };
  },
  computed: {
    modalId() {
      return `gallery-item-modal-${this.galleryItemId}`;
    },
  },
});
